/* eslint-disable */

<template>
  <div id="custom266206729396551680">
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
      <div class="vx-col w-1/2">
        <vx-card class="mb-base">

          <div>
            <div class="border-white border-solid border-2 rounded mb-5">
              <div class="flex bg-primary-gradient p-5 ">
                <feather-icon icon="CommandIcon" svgClasses="mr-4 self-center"/>
                <h3 class="font-bold self-center">Drag & Drop Options</h3>
              </div>
              <div class="p-5">
                <vue-draggable-container id="wordBank" class="wordBank">
                  <h5 class="dragBlock my-4 font-semibold cursor-pointer" id="command1">#1/user/bin/ruby</h5>
                  <h5 class="dragBlock my-4 font-semibold cursor-pointer" id="command3">run_scan(sys.argv[1], ports)</h5>
                  <h5 class="dragBlock my-4 font-semibold cursor-pointer" id="command4">ports - [21, 22]</h5>
                  <h5 class="dragBlock my-4 font-semibold cursor-pointer" id="command2">for SPORT in SPORTS:<br>&nbsp;&nbsp;&nbsp;try:<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s.connect((ip,port))<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;print("%s:%s - OPEN" % (ip, port))<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>&nbsp;&nbsp;&nbsp;except socket.timeout<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;print("%s%s - TIMEOUT" % (ip, port))<br><br>&nbsp;&nbsp;except socket.error<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;print("%s%s - CLOSED" % (ip, port))<br><br>&nbsp;&nbsp;&nbsp;finally:<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s.close()</h5>
                  <h5 class="dragBlock my-4 font-semibold cursor-pointer" id="command5">for port in ports:<br>&nbsp;&nbsp;&nbsp;try:<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s.connect((ip,port))<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;print("%s:%s - OPEN" % (ip, port))<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>&nbsp;&nbsp;&nbsp;except socket.timeout<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;print("%s%s - TIMEOUT" % (ip, port))<br>&zwj;</h5>
                </vue-draggable-container>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-1/2 ">
        <vx-card class="mb-base">
          <div class="border-white border-solid border-2 rounded" style="background: #000000">
            <div class="flex bg-black p-5 ">
              <feather-icon icon="CommandIcon" svgClasses="mr-4 self-center"/>
              <h3 class="font-bold self-center">Command</h3>
            </div>
            <div class="p-5">
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mb-5" id="input0"/>
              <h4 class="mb-2">import socket</h4>
              <h4 class="mb-5">import sys</h4>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mb-5" id="input1"/>
              <h4 class="mb-5">def port_scan(ip, ports)&nbsp;:&nbsp;<br>&nbsp;&nbsp;&nbsp;s -socket.socket(socket.AF_INET, socket.SOCK_STREAM)<br>&nbsp;&nbsp;&nbsp;s.settimeout(2.0)</h4>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mb-5" id="input2"/>
              <h4 class="mb-5">if_name_ - `_min_` :<br>&nbsp;&nbsp;&nbsp;if len(sys.argv) &lt; 2<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;print('Execution requires a target IP&nbsp;address. Exiting...';<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;exit(1)<br>&nbsp;&nbsp;&nbsp;else:</h4>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mb-5" id="input3"/>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    </vue-sortable>
  </div>


</template>

<script>

import Prism from 'vue-prism-component'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      }

    }
  },
  methods: {
    markSimulation () {

      let total_score = 0

      if (document.getElementById('input0').firstElementChild.id === 'command1') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else if (document.getElementById('input0').textContent !== '') {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').firstElementChild.id === 'command5') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else if (document.getElementById('input1').textContent !== '') {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').firstElementChild.id === 'command2') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else if (document.getElementById('input2').textContent !== '') {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input3').firstElementChild.id === 'command3') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else if (document.getElementById('input3').textContent !== '') {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }


      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    },
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel()
        }
      }
    }
  },
  components: {
    Prism,
    draggable
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>
<style lang="scss">
#custom266206729396551680 {
  .wordBank {
    .dragBlock {
      width: 99%;

      &.currently-dragging-standard {
        width: auto;
      }

    }
  }

  .answerStandard {
    .dragBlock {
      text-align: left;
      min-width: 93%;
    }
  }
}
</style>
